module.exports = __webpack_public_path__ + "img/ch38.c994e2ff.jpg";